:host {
    display: block;
    height: 100%;
    width: 100%;

    --pdf-viewer-top-offset: 0px;
    --pdf-viewer-bottom-offset: 0px;
}

iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    visibility: hidden;
    &.loaded {
        visibility: visible;
    }
}
